/* 曹操傳・第 12 章／劉備傳・第 9 章：定軍山與漢中（219 年）
 * 東北是定軍山（劉備、黃忠在山上），山下南側是夏侯淵的營，營外有三處鹿角；往西一條谷道通到陽平關。 */
export const HILL = [6600, 1200], CAMP = [6300, 2700], ABATIS = [[5800, 2250], [6400, 2150], [6950, 2350]], EXIT = [900, 2900], HQ = [3800, 2900];
export default {
  id: 'dingjun', name: '定軍山', W: 9000, H: 4800, seed: 219,
  bases: [CAMP, HILL],
  roads: [{ pts: [EXIT, [2200, 3000], HQ, [5000, 2900], CAMP], w: 140 }, { pts: [CAMP, [6500, 2000], HILL], w: 110 }],
  rocks: [[5600, 1000, 560, 260], [7600, 1300, 520, 260], [2000, 1700, 520, 260], [3000, 4000, 520, 220], [5000, 4100, 460, 200], [1500, 4000, 400, 190]],
  woods: 0.5,
  sight: 0.8,
  clearings: [[CAMP[0], CAMP[1], 650], [HILL[0], HILL[1], 450], [HQ[0], HQ[1], 500], [EXIT[0], EXIT[1], 350], ...ABATIS.map(([x, y]) => [x, y, 200])],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 8, r: 460, chief: true, col: '#3b5a99', flag: '夏' }, { x: HQ[0], y: HQ[1], n: 8, r: 420, chief: true, col: '#3b5a99', flag: '曹' }, { x: HILL[0], y: HILL[1], n: 5, r: 300, col: '#3e7b50', flag: '漢' }],
  grass: [[2600, 2500, 240, 110], [4600, 3300, 240, 110], [1700, 3300, 220, 100]],
};
